interface ModalDefects2CommentSectionProps {
    handleChange: (e: React.ChangeEvent<HTMLInputElement>, dataKey: string) => void;
    updateCommentBlank: boolean;
    comment: string;
    showCommentBox: boolean;
}

const ModalDefects2CommentSection: React.FunctionComponent<ModalDefects2CommentSectionProps> = ({
    handleChange,
    updateCommentBlank,
    comment,
    showCommentBox
}) => {
    if (!showCommentBox) return null;

    return (
        <div className="comment-section mt-3">
            <div className="form-group">
                <label htmlFor="palletUpdateComment">Comment</label>
                <input
                    name="palletUpdateComment"
                    type="text"
                    id="palletUpdateComment"
                    maxLength={255}
                    value={comment}
                    className={`form-control ${updateCommentBlank ? "is-invalid" : ""}`}
                    onChange={e => handleChange(e, "")}
                />
                {updateCommentBlank && <div className="invalid-feedback">Comment cannot be empty.</div>}
            </div>
        </div>
    );
};

ModalDefects2CommentSection.defaultProps = {
    updateCommentBlank: false,
    comment: "",
    showCommentBox: false
};

export default ModalDefects2CommentSection;
